import React from 'react';
import TextField from '@mui/material/TextField';
import { FormHelperText, InputAdornment } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { Currency, MOBILE_BREAKPOINT } from '../../../utils/constants';
import classes from './form.module.scss';
import { useWindowSize } from '../../../utils/hooks';

function PermanentForm(props) {
  const { values, errors, touched, changeHandler } = props;
  const size = useWindowSize();

  return (
    <div
      className={`d-flex ${
        size.width > MOBILE_BREAKPOINT ? 'flex-row' : 'flex-column'
      } justify-content-center align-items-start gap-2`}
    >
      <div className="d-flex flex-column align-items-center">
        <span className={classes.fieldLabel}>Annual Salary</span>
        <TextField
          variant="outlined"
          value={values.salary}
          onChange={(e) => changeHandler('salary', e.target.value?.replace(/[^0-9]/g, ''))}
          sx={{
            width: {
              sm: '100%',
              md: '110px'
            },
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiOutlinedInput-root': {
              borderRadius: 0
            }
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">/ year</InputAdornment>
          }}
          error={touched.salary && !!errors.salary}
          helperText={touched.salary && errors.salary}
        />
      </div>
      <div className="d-flex flex-column align-items-center">
        <span className={classes.fieldLabel}>Currency</span>
        <Autocomplete
          value={values.currency}
          disablePortal
          disableClearable
          options={Currency}
          getOptionLabel={(option) => option || ''}
          onChange={(e, value) => changeHandler('currency', value)}
          sx={{
            width: {
              sm: '100%',
              md: '110px'
            },
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
              width: '100%'
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: 0
            }
          }}
          renderInput={(params) => <TextField {...params} />}
        />
        {touched.currency && errors.currency && <FormHelperText error>{errors.currency}</FormHelperText>}
      </div>
    </div>
  );
}

export default PermanentForm;
